export class SceneAssetInstanceMetadata {
    constructor() {
        // TODO: Could be other things?
        this.owner = null;
    }
}
export class SceneAssetMeshInstanceMetadata {
    constructor(asset_instance_metadata, source_mesh) {
        this.custom_raycast_acceleration_structure = null;
        this.asset_instance_metadata = asset_instance_metadata;
        this._source_mesh = source_mesh;
    }
    get raycast_acceleration_structure() {
        var _a;
        return (_a = this.custom_raycast_acceleration_structure) !== null && _a !== void 0 ? _a : this._source_mesh.raycast_acceleration_structure;
    }
}
//# sourceMappingURL=SceneAssetMetadata.js.map